import React from 'react';
import { Container, Row, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { XCircle } from 'lucide-react';
import { ReactComponent as LeftBg } from '../../assets/images/bg/login-bgleft.svg';
import { ReactComponent as RightBg } from '../../assets/images/bg/login-bg-right.svg';

const FailedPayment = () => {
  return (
    <>
      <LeftBg className="position-absolute left bottom-0" />
      <RightBg className="position-absolute end-0 top" />
      <Container
        fluid
        className="d-flex justify-content-center align-items-center min-vh-100 position-relative"
      >
        <Row className="justify-content-center">
          <Card className="shadow-lg text-center p-4" style={{ maxWidth: '420px' }}>
            <CardBody>
              <XCircle size={64} className="text-danger mb-3" />
              <CardTitle tag="h1" className="h4 text-dark mb-2">
                El pago no se ha podido completar
              </CardTitle>
              <CardText className="text-muted mb-4">
                Ha ocurrido un problema al procesar tu pago. No se ha realizado ningún cargo en tu
                tarjeta. Puedes volver a intentarlo desde el enlace que recibiste en tu correo.
              </CardText>
              <p className="text-muted text-center mt-4">
                ¿Necesitas ayuda?{' '}
                <a href="mailto:soporte@cedetecgroup.com" className="text-danger">
                  Contáctanos
                </a>
              </p>
            </CardBody>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default FailedPayment;
